<template>
  <div class="retailers-tips">
    <p>tips from your retailers</p>
    <div v-if="retailerTipsTotal > 2" class="search-wrapper">
      <input 
          class="search-bar-tips"
          type="text"
          v-model="search">
    </div>

    <div v-if="searchResults.length > 0">
      <div class="retailer-tips-list">
        <div v-for="retailer in searchResults" :key="retailer.id">
          <div v-if="retailer.ads_image_preferences">
            <p class="retailer-name">{{ retailer.name }}</p>
            <p class="details"> {{ retailer.ads_image_preferences }} </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="details">no results</div>
  </div>
</template>

<script>
  export default {
    props: {
      selectedRetailers: Array,
      retailerTipsTotal: Number,
    },

    name: 'RetailerTips',

    data() {
      return {
        search: '',
      }
    }, 

    computed: {
      searchResults() {
        return this.selectedRetailers.filter(retailer => {
          return retailer.name.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.retailers-tips
  border: 1px solid $primary-color
  border-radius: 32px 0 0 32px
  padding: .75rem

  p
    color: $negative-color
    font-size: .9rem
    margin-bottom: .5rem

.search-bar-tips
  border-radius: 14px
  border: 1px solid $primary-color
  font-size: 1rem
  margin-bottom: .5rem
  padding: 0 .5rem
  width: 80%

.retailer-tips-list
  text-align: left
  padding-right: 1.5rem
  max-height: 200px
  overflow: scroll

  .retailer-name
    font-weight: bold
    color: $title-color
    padding: 0 0 .25rem 0
  
.details
  color: $negative-color
  font-size: .9rem
  line-height: 1.15
  margin: 0 0 .75rem .5rem
</style>